import Seo from "../Components/Seo";
import { buildvivekvaniDescription, buildvivekvaniJsonLd, buildvivekvaniKeywords } from "../utils/Vivekvaniseo";

type vivekvaniSeoProps = {
  vivekvani: any;
  canonicalPath: string;
};

const vivekvaniSeo = ({ vivekvani, canonicalPath }: vivekvaniSeoProps) => {
    debugger;
  if (!vivekvani) return null;

  const title = vivekvani?.pageTitle || vivekvani?.ogTitle || (vivekvani?.name ? `${vivekvani.name} | Gita Seva` : "Gita Seva vivekvani");
  const description = vivekvani?.pageDescription || vivekvani?.ogDescription || buildvivekvaniDescription(vivekvani);
  const keywords = buildvivekvaniKeywords(vivekvani);
  const image = vivekvani?.ogImage || vivekvani?.vivekvaniPath || "";
  const jsonLd = buildvivekvaniJsonLd(vivekvani, canonicalPath);

  return (
    <Seo
      title={title}
      description={description}
      keywords={keywords}
      path={canonicalPath}
      image={image}
      ogImageWidth={1200}
      ogImageHeight={630}
      ogType="vivekvani"
      robots="index,follow"
      jsonLd={jsonLd}
    />
  );
};

export default vivekvaniSeo;






